export default "/one_drive.20367c52-2b9d41.png";